import { useMemo } from "react";
import { CalendarDays } from "lucide-react";
import { CALLBACK_COPY, callbackMinimumDate, visitorTimezone } from "../../data/callbackCopy";

export const CallbackFields = ({ form, setForm, locale, inputCls }) => {
  const copy = CALLBACK_COPY[locale];
  const zones = useMemo(() => {
    const supported = typeof Intl.supportedValuesOf === "function"
      ? Intl.supportedValuesOf("timeZone")
      : ["America/Toronto", "America/New_York", "America/Chicago", "America/Denver", "America/Phoenix", "America/Los_Angeles", "Europe/Paris", "Europe/Madrid"];
    return [...new Set([visitorTimezone(), "UTC", ...supported])].sort();
  }, []);
  const update = (field) => (event) => setForm((previous) => ({ ...previous, [field]: event.target.value }));
  return (
    <fieldset data-testid="callback-schedule" className="min-w-0 space-y-3 border-t border-slate-100 pt-4">
      <legend className="flex items-center gap-2 text-sm font-semibold text-brand-navy">
        <CalendarDays size={16} /> {copy.requested}
      </legend>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 min-w-0">
        <label className="min-w-0 text-xs text-slate-600">
          {copy.date}
          <input data-testid="callback-date" type="date" required value={form.callback_date}
            min={callbackMinimumDate(form.callback_timezone)} onChange={update("callback_date")}
            className={`${inputCls} block mt-1 min-w-0 max-w-full`} />
        </label>
        <label className="min-w-0 text-xs text-slate-600">
          {copy.window}
          <select data-testid="callback-window" required value={form.callback_window}
            onChange={update("callback_window")} className={`${inputCls} mt-1 min-w-0`}>
            <option value="">{copy.choose}</option>
            {["morning", "afternoon", "either"].map((window) => (
              <option key={window} value={window}>{copy[window]}</option>
            ))}
          </select>
        </label>
      </div>
      <label className="block text-xs text-slate-600 min-w-0">
        {copy.timezone}
        <select data-testid="callback-timezone" required value={form.callback_timezone}
          onChange={update("callback_timezone")} className={`${inputCls} mt-1 min-w-0`}>
          {zones.map((zone) => <option key={zone} value={zone}>{zone.replace(/_/g, " ")}</option>)}
        </select>
      </label>
      <p data-testid="callback-request-notice" className="text-xs leading-relaxed text-slate-500">{copy.note}</p>
    </fieldset>
  );
};